import React, { Component } from 'react'
import { Header, FormikForm, TextField, Button, Toast, Error, PageWrapper } from '../components'
import { Formik, Field } from 'formik'
import { changePasswordValidator } from '../utlis/validators'
import axios from 'axios'
import { API_URL } from '../constants'
import { get } from 'lodash'

class ChangePassword extends Component {
  state = { openToast: false, isLoading: false, error: '' }
  handleClose = async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
    this.props.history.goBack()
  }
  render() {
    const { openToast, isLoading, error } = this.state
    return (
      <React.Fragment>
        <Header
          title={'Change Password'}
          icon="arrowBack"
          onClickBack={() => this.props.history.replace('/user-profile/edit')}
          color="#fff"
        />
        <PageWrapper height="100%" viewPadding="22.4% 8% 6%">
          <Formik
            enableReinitialize
            initialValues={{ oldPassword: '', newPassword: '', confirmNewPassword: '' }}
            validateOnChange
            validate={changePasswordValidator}
            onSubmit={async val => {
              this.setState({ isLoading: true })
              try {
                await axios.post(`${API_URL}/users/change-password`, {
                  oldPassword: val.oldPassword,
                  newPassword: val.newPassword
                })
                await this.setState({ isLoading: false, openToast: true, error: '' })
              } catch (error) {
                console.log('ERR', error)
                this.setState({
                  isLoading: false,
                  error:
                    get(error, 'message', '') === 'Request failed with status code 400'
                      ? 'Invalid current password'
                      : get(error, 'message', '')
                })
              }
            }}
            render={formikBag => (
              <FormikForm>
                <Field
                  name="oldPassword"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="password"
                      hideEye
                      label="Enter Old Password"
                      margin="30px 0"
                      width="auto"
                      fontSize="18px"
                      fontColor="#124b5f"
                      required
                      error={formikBag.errors.oldPassword}
                    />
                  )}
                />
                <Field
                  name="newPassword"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="password"
                      hideEye
                      label="Enter New Password"
                      margin="30px 0"
                      width="auto"
                      fontSize="18px"
                      fontColor="#124b5f"
                      required
                      error={formikBag.errors.newPassword}
                    />
                  )}
                />
                <Field
                  name="confirmNewPassword"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="password"
                      hideEye
                      label="Confirm New Password"
                      margin="30px 0"
                      width="auto"
                      fontSize="18px"
                      fontColor="#124b5f"
                      required
                      error={formikBag.errors.confirmNewPassword}
                    />
                  )}
                />
                <Button
                  volume="filled"
                  type="submit"
                  label="Change Password"
                  margin={'0 0 20px 0'}
                  isLoading={isLoading}
                  disabled={isLoading}
                />
                <Error response>{error}</Error>
              </FormikForm>
            )}
          />
        </PageWrapper>
        <Toast open={openToast} message="Password changed successfully" onClose={this.handleClose} />
      </React.Fragment>
    )
  }
}

export default ChangePassword



// WEBPACK FOOTER //
// ./src/pages/ChangePassword.js